import React from "react";

const TICKS = [
  { v: "Fail", d: "The response fails on this criterion." },
  { v: "Borderline", d: "Partially meets this criterion." },
  { v: "Pass", d: "Fully meets this criterion." },
];

// ONE reusable evaluation card. Renders only the single active target criterion.
export default function EvalCard({ item, tick, rationale, onTick, onRationale, blockPaste = false, disabled = false }) {
  return (
    <div className="border border-[#E5E5E5] bg-white rounded-sm" data-testid="eval-card">
      <div className="p-5 sm:p-7 space-y-5">
        <div>
          <span className="eyebrow text-[#A3A3A3]">User request</span>
          <p className="mt-1.5 text-[#0A0A0A] leading-relaxed whitespace-pre-wrap" data-testid="eval-request">{item.user_request}</p>
        </div>
        {item.source ? (
          <div>
            <span className="eyebrow text-[#A3A3A3]">Source</span>
            <p className="mt-1.5 text-[#525252] leading-relaxed whitespace-pre-wrap">{item.source}</p>
          </div>
        ) : null}
        <div className="border-l-2 border-[#0A0A0A]/15 pl-4">
          <span className="eyebrow text-[#A3A3A3]">AI response</span>
          <p className="mt-1.5 text-[#0A0A0A] leading-relaxed whitespace-pre-wrap" data-testid="eval-response">{item.ai_response}</p>
        </div>

        <div className="pt-1">
          <span className="eyebrow text-[#C79447]">Target criterion</span>
          <p className="mt-1.5 font-display text-lg font-medium tracking-tight" data-testid="eval-criterion">
            {item.target_criterion} — {item.criterion_label}
          </p>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2.5">
            {TICKS.map((t) => (
              <button key={t.v} data-testid={`tick-${t.v}`} disabled={disabled} onClick={() => onTick(t.v)}
                className={`text-left px-4 py-3 rounded-sm border text-sm transition-colors ${tick === t.v ? "border-[#0A0A0A] bg-[#0A0A0A] text-white" : "border-[#E5E5E5] hover:border-[#0A0A0A]/40"}`}>
                <span className="font-medium block">{t.v}</span>
                <span className={`text-xs ${tick === t.v ? "text-white/70" : "text-[#A3A3A3]"}`}>{t.d}</span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="eyebrow text-[#A3A3A3]">Rationale</label>
          <textarea data-testid="eval-rationale" rows={3} value={rationale} disabled={disabled}
            onChange={(e) => onRationale(e.target.value)}
            onPaste={blockPaste ? (e) => { e.preventDefault(); onRationale(rationale, true); } : undefined}
            placeholder="Briefly explain your judgment against this criterion."
            className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-3 py-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-black" />
        </div>
      </div>
    </div>
  );
}
